export const SET_REQUEST_CONTEXT = 'SET_REQUEST_CONTEXT';
export const SET_REQUEST_DETAILS = 'SET_REQUEST_DETAILS';

export const CONFIG = 'CONFIG';
export const CONFIG_REQUEST = 'CONFIG_REQUEST';
export const CONFIG_SUCCESS = 'CONFIG_SUCCESS';
export const CONFIG_FAILURE = 'CONFIG_FAILURE';

export const SET_RESTAURANTS_SORT = 'SET_RESTAURANTS_SORT';
export const SET_RESTAURANTS_OFFER_TYPE = 'SET_RESTAURANTS_OFFER_TYPE';
export const SET_DELIVERY_TIME = 'SET_DELIVERY_TIME';
export const SET_RESTAURANTS_SEARCH_TERM = 'SET_RESTAURANTS_SEARCH_TERM';
export const TOGGLE_DATE_TIME_MODAL = 'TOGGLE_DATE_TIME_MODAL';

export const BASKET = 'BASKET';
export const BASKET_REQUEST = 'BASKET_REQUEST';
export const BASKET_SUCCESS = 'BASKET_SUCCESS';
export const BASKET_FAILURE = 'BASKET_FAILURE';

export const SET_HELP_ORDER_ID = 'SET_HELP_ORDER_ID';

export const SET_SPECIFIC_HELP_PAGE = 'SET_SPECIFIC_HELP_PAGE';

export const SET_ORDER_HELP_MODAL_IS_OPEN = 'SET_ORDER_HELP_MODAL_IS_OPEN';
export const SET_ORDER_HELP_MODAL_PAGE = 'SET_ORDER_HELP_MODAL_PAGE';

export const RESET_INTERACTION = 'RESET_INTERACTION';
export const RELOAD_INTERACTION = 'RELOAD_INTERACTION';

export const UPDATE_INTERACTION = 'UPDATE_INTERACTION';
export const UPDATE_INTERACTION_REQUEST = 'UPDATE_INTERACTION_REQUEST';
export const UPDATE_INTERACTION_SUCCESS = 'UPDATE_INTERACTION_SUCCESS';
export const UPDATE_INTERACTION_FAILURE = 'UPDATE_INTERACTION_FAILURE';

export const CLOSE_INTERACTION_DIALOG = 'CLOSE_INTERACTION_DIALOG';

export const INIT_ORDER_HELP = 'INIT_ORDER_HELP';

export const ORDER_HELP_ACTIONS = 'ORDER_HELP_ACTIONS';
export const ORDER_HELP_ACTIONS_REQUEST = 'ORDER_HELP_ACTIONS_REQUEST';
export const ORDER_HELP_ACTIONS_SUCCESS = 'ORDER_HELP_ACTIONS_SUCCESS';
export const ORDER_HELP_ACTIONS_FAILURE = 'ORDER_HELP_ACTIONS_FAILURE';

export const ORDER_HELP_FEEDBACK = 'ORDER_HELP_FEEDBACK';
export const ORDER_HELP_FEEDBACK_REQUEST = 'ORDER_HELP_FEEDBACK_REQUEST';
export const ORDER_HELP_FEEDBACK_FAILURE = 'ORDER_HELP_FEEDBACK_FAILURE';
export const ORDER_HELP_FEEDBACK_SUCCESS = 'ORDER_HELP_FEEDBACK_SUCCESS';
export const ORDER_HELP_FEEDBACK_SCORE = 'ORDER_HELP_FEEDBACK_SCORE';
export const ORDER_HELP_FEEDBACK_SCORE_REQUEST = 'ORDER_HELP_FEEDBACK_SCORE_REQUEST';
export const ORDER_HELP_FEEDBACK_SCORE_FAILURE = 'ORDER_HELP_FEEDBACK_SCORE_FAILURE';
export const ORDER_HELP_FEEDBACK_SCORE_SUCCESS = 'ORDER_HELP_FEEDBACK_SCORE_SUCCESS';

export const LOCAL_STORAGE_ORDER_STATUS = 'LOCAL_STORAGE_ORDER_STATUS';
export const LOCAL_STORAGE_ORDER_STATUS_FAILED_ATTEMPTS =
  'LOCAL_STORAGE_ORDER_STATUS_FAILED_ATTEMPTS';
export const ORDER_STATUS = 'ORDER_STATUS';
export const ORDER_STATUS_REQUEST = 'ORDER_STATUS_REQUEST';
export const ORDER_STATUS_SUCCESS = 'ORDER_STATUS_SUCCESS';
export const ORDER_STATUS_FAILURE = 'ORDER_STATUS_FAILURE';
export const ORDER_STATUS_TRACKING_DATA = 'ORDER_STATUS_TRACKING_DATA';
export const ORDER_STATUS_TRACKING_DATA_REQUEST = 'ORDER_STATUS_TRACKING_DATA_REQUEST';
export const ORDER_STATUS_TRACKING_DATA_SUCCESS = 'ORDER_STATUS_TRACKING_DATA_SUCCESS';
export const ORDER_STATUS_TRACKING_DATA_FAILURE = 'ORDER_STATUS_TRACKING_DATA_FAILURE';
export const ORDER_STATUS_WHATSAPP = 'ORDER_STATUS_WHATSAPP';
export const ORDER_STATUS_WHATSAPP_REQUEST = 'ORDER_STATUS_WHATSAPP_REQUEST';
export const ORDER_STATUS_WHATSAPP_SUCCESS = 'ORDER_STATUS_WHATSAPP_SUCCESS';
export const ORDER_STATUS_WHATSAPP_FAILURE = 'ORDER_STATUS_WHATSAPP_FAILURE';
export const ORDER_STATUS_SHARE = 'ORDER_STATUS_SHARE';
export const SET_ORDER_STATUS_SHARED = 'SET_ORDER_STATUS_SHARED';
export const ORDER_STATUS_SHARE_REQUEST = 'ORDER_STATUS_SHARE_REQUEST';
export const ORDER_STATUS_SHARE_SUCCESS = 'ORDER_STATUS_SHARE_SUCCESS';
export const ORDER_STATUS_SHARE_FAILURE = 'ORDER_STATUS_SHARE_FAILURE';

export const SET_INFO_BANNER_MODAL_IS_OPEN = 'SET_INFO_BANNER_MODAL_IS_OPEN';

export const ORDER_PUNCH_CARD = 'ORDER_PUNCH_CARD';
export const ORDER_PUNCH_CARD_REQUEST = 'ORDER_PUNCH_CARD_REQUEST';
export const ORDER_PUNCH_CARD_SUCCESS = 'ORDER_PUNCH_CARD_SUCCESS';
export const ORDER_PUNCH_CARD_FAILURE = 'ORDER_PUNCH_CARD_FAILURE';

export const SET_LIVE_CHAT_DEPARTMENT = 'SET_LIVE_CHAT_DEPARTMENT';

export const UPDATE_LOCATION_DETAILS = 'UPDATE_LOCATION_DETAILS';
export const RESTAURANT_LOCATION_SEARCH = 'RESTAURANT_LOCATION_SEARCH';
export const RESTAURANT_LOCATION_SEARCH_FAILURE = 'RESTAURANT_LOCATION_SEARCH_FAILURE';
export const RESTAURANT_LOCATION_SEARCH_REQUEST = 'RESTAURANT_LOCATION_SEARCH_REQUEST';
export const RESTAURANT_LOCATION_SEARCH_SUCCESS = 'RESTAURANT_LOCATION_SEARCH_SUCCESS';

export const BRAND_LOCATION_SEARCH = 'BRAND_LOCATION_SEARCH';
export const BRAND_LOCATION_SEARCH_FAILURE = 'BRAND_LOCATION_SEARCH_FAILURE';
export const BRAND_LOCATION_SEARCH_REQUEST = 'BRAND_LOCATION_SEARCH_REQUEST';
export const BRAND_LOCATION_SEARCH_SUCCESS = 'BRAND_LOCATION_SEARCH_SUCCESS';

export const BRAND_SUGGESTED_MENU_SEARCH = 'BRAND_SUGGESTED_MENU_SEARCH';
export const BRAND_SUGGESTED_MENU_SEARCH_FAILURE = 'BRAND_SUGGESTED_MENU_SEARCH_FAILURE';
export const BRAND_SUGGESTED_MENU_SEARCH_REQUEST = 'BRAND_SUGGESTED_MENU_SEARCH_REQUEST';
export const BRAND_SUGGESTED_MENU_SEARCH_SUCCESS = 'BRAND_SUGGESTED_MENU_SEARCH_SUCCESS';

export const RECENT_LOCATIONS = 'RECENT_LOCATIONS';
export const RECENT_LOCATIONS_FAILURE = 'RECENT_LOCATIONS_FAILURE';
export const RECENT_LOCATIONS_SUCCESS = 'RECENT_LOCATIONS_SUCCESS';
export const RECENT_LOCATIONS_REQUEST = 'RECENT_LOCATIONS_REQUEST';

export const LOCATION_SEARCH_MODAL_SHOW = 'LOCATION_SEARCH_MODAL_SHOW';
export const LOCATION_SEARCH_MODAL_HIDE = 'LOCATION_SEARCH_MODAL_HIDE';

export const HOMEPAGE_FEATURED_CONTENT = 'HOMEPAGE_FEATURED_CONTENT';
export const HOMEPAGE_FEATURED_CONTENT_REQUEST = 'HOMEPAGE_FEATURED_CONTENT_REQUEST';
export const HOMEPAGE_FEATURED_CONTENT_SUCCESS = 'HOMEPAGE_FEATURED_CONTENT_SUCCESS';
export const HOMEPAGE_FEATURED_CONTENT_FAILURE = 'HOMEPAGE_FEATURED_CONTENT_FAILURE';

export const HOMEPAGE_HERO_CUISINE_IMAGE = 'HOMEPAGE_HERO_CUISINE_IMAGE';
export const HOMEPAGE_HERO_SHAPE_COLOR = 'HOMEPAGE_HERO_SHAPE_COLOR';

export const HOMEPAGE_FILTER_SELECTED = 'HOMEPAGE_FILTER_SELECTED';
export const HOMEPAGE_FILTER_CLEAR = 'HOMEPAGE_FILTER_CLEAR';

export const VOTE_AREA = 'VOTE_AREA';
export const VOTE_AREA_FAILURE = 'VOTE_AREA_FAILURE';
export const VOTE_AREA_SUCCESS = 'VOTE_AREA_SUCCESS';

export const INVITE_MODAL_SHOW = 'INVITE_MODAL_SHOW';
export const INVITE_MODAL_CLOSE = 'INVITE_MODAL_CLOSE';

export const CREDIT_REDEMPTION = 'CREDIT_REDEMPTION';
export const CREDIT_REDEMPTION_REQUEST = 'CREDIT_REDEMPTION_REQUEST';
export const CREDIT_REDEMPTION_SUCCESS = 'CREDIT_REDEMPTION_SUCCESS';
export const CREDIT_REDEMPTION_FAILURE = 'CREDIT_REDEMPTION_FAILURE';

export const ORDER_HISTORY = 'ORDER_HISTORY';
export const ORDER_HISTORY_REQUEST = 'ORDER_HISTORY_REQUEST';
export const ORDER_HISTORY_SUCCESS = 'ORDER_HISTORY_SUCCESS';
export const ORDER_HISTORY_FAILURE = 'ORDER_HISTORY_FAILURE';
export const LOAD_MORE_ORDER_HISTORY = 'LOAD_MORE_ORDER_HISTORY';
export const HIDE_LOAD_MORE_ORDER_HISTORY = 'HIDE_LOAD_MORE_ORDER_HISTORY';

export const ORDER_RECEIPT = 'ORDER_RECEIPT';
export const ORDER_RECEIPT_REQUEST = 'ORDER_RECEIPT_REQUEST';
export const ORDER_RECEIPT_SUCCESS = 'ORDER_RECEIPT_SUCCESS';
export const ORDER_RECEIPT_FAILURE = 'ORDER_RECEIPT_FAILURE';

export const ORDER = 'ORDER';
export const ORDER_REQUEST = 'ORDER_REQUEST';
export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_FAILURE = 'ORDER_FAILURE';

export const ORDER_RATING = 'ORDER_RATING';
export const ORDER_RATING_REQUEST = 'ORDER_RATING_REQUEST';
export const ORDER_RATING_SUCCESS = 'ORDER_RATING_SUCCESS';
export const ORDER_RATING_FAILURE = 'ORDER_RATING_FAILURE';

export const ORDER_RATING_DISMISS = 'ORDER_RATING_DISMISS';
export const ORDER_RATING_DISMISS_REQUEST = 'ORDER_RATING_DISMISS_REQUEST';
export const ORDER_RATING_DISMISS_SUCCESS = 'ORDER_RATING_DISMISS_SUCCESS';
export const ORDER_RATING_DISMISS_FAILURE = 'ORDER_RATING_DISMISS_FAILURE';

export const MEAL_CARD_ISSUERS = 'MEAL_CARD_ISSUERS';
export const MEAL_CARD_ISSUERS_REQUEST = 'MEAL_CARD_ISSUERS_REQUEST';
export const MEAL_CARD_ISSUERS_SUCCESS = 'MEAL_CARD_ISSUERS_SUCCESS';
export const MEAL_CARD_ISSUERS_FAILURE = 'MEAL_CARD_ISSUERS_FAILURE';
export const SHOW_MEAL_CARD_MODAL = 'SHOW_MEAL_CARD_MODAL';
export const HIDE_MEAL_CARD_MODAL = 'HIDE_MEAL_CARD_MODAL';

export const STATIC_PAGE = 'STATIC_PAGE';
export const STATIC_PAGE_REQUEST = 'STATIC_PAGE_REQUEST';
export const STATIC_PAGE_SUCCESS = 'STATIC_PAGE_SUCCESS';
export const STATIC_PAGE_FAILURE = 'STATIC_PAGE_FAILURE';

export const REFERRAL = 'REFERRAL';
export const REFERRAL_REQUEST = 'REFERRAL_REQUEST';
export const REFERRAL_SUCCESS = 'REFERRAL_SUCCESS';
export const REFERRAL_FAILURE = 'REFERRAL_FAILURE';

export const USER_REGISTRATION = 'USER_REGISTRATION';
export const USER_REGISTRATION_REQUEST = 'USER_REGISTRATION_REQUEST';
export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_FAILURE = 'USER_REGISTRATION_FAILURE';

export const VOUCHER = 'VOUCHER';
export const VOUCHER_REQUEST = 'VOUCHER_REQUEST';
export const VOUCHER_SUCCESS = 'VOUCHER_SUCCESS';
export const VOUCHER_FAILURE = 'VOUCHER_FAILURE';

export const FETCH_HOME_FEED = 'FETCH_HOME_FEED';
export const FETCH_HOME_FEED_REQUEST = 'FETCH_HOME_FEED_REQUEST';
export const FETCH_HOME_FEED_SUCCESS = 'FETCH_HOME_FEED_SUCCESS';
export const FETCH_HOME_FEED_FAILURE = 'FETCH_HOME_FEED_FAILURE';
export const FETCH_HOME_SEARCH_RESULTS = 'FETCH_HOME_SEARCH_RESULTS';
export const FETCH_HOME_SEARCH_RESULTS_REQUEST = 'FETCH_HOME_SEARCH_RESULTS_REQUEST';
export const FETCH_HOME_SEARCH_RESULTS_SUCCESS = 'FETCH_HOME_SEARCH_RESULTS_SUCCESS';
export const FETCH_HOME_SEARCH_RESULTS_FAILURE = 'FETCH_HOME_SEARCH_RESULTS_FAILURE';
export const FETCH_HOME_FULFILLMENT_TIMES = 'FETCH_HOME_FULFILLMENT_TIMES';
export const FETCH_HOME_FULFILLMENT_TIMES_REQUEST = 'FETCH_HOME_FULFILLMENT_TIMES_REQUEST';
export const FETCH_HOME_FULFILLMENT_TIMES_SUCCESS = 'FETCH_HOME_FULFILLMENT_TIMES_SUCCESS';
export const FETCH_HOME_FULFILLMENT_TIMES_FAILURE = 'FETCH_HOME_FULFILLMENT_TIMES_FAILURE';
export const SET_HOME_FILTERS = 'SET_HOME_FILTERS';
export const SET_HOME_QUERY = 'SET_HOME_QUERY';
export const SET_COLLECTION_FILTER = 'SET_COLLECTION_FILTER';
export const SHOW_DATE_TIME_MODAL = 'SHOW_DATE_TIME_MODAL';
export const HIDE_DATE_TIME_MODAL = 'HIDE_DATE_TIME_MODAL';
export const SHOW_LOGISTICS_MODAL = 'SHOW_LOGISTICS_MODAL';
export const HIDE_LOGISTICS_MODAL = 'HIDE_LOGISTICS_MODAL';
export const CLEAR_HOME_SEARCH_RESULTS = 'CLEAR_HOME_SEARCH_RESULTS';

export const CUISINE = 'CUISINE';
export const CUISINE_REQUEST = 'CUISINE_REQUEST';
export const CUISINE_SUCCESS = 'CUISINE_SUCCESS';
export const CUISINE_FAILURE = 'CUISINE_FAILURE';
export const CUISINE_RESTAURANTS = 'CUISINE_RESTAURANTS';
export const CUISINE_RESTAURANTS_REQUEST = 'CUISINE_RESTAURANTS_REQUEST';
export const CUISINE_RESTAURANTS_SUCCESS = 'CUISINE_RESTAURANTS_SUCCESS';
export const CUISINE_RESTAURANTS_FAILURE = 'CUISINE_RESTAURANTS_FAILURE';

export const CUISINES = 'CUISINES';
export const CUISINES_REQUEST = 'CUISINES_REQUEST';
export const CUISINES_SUCCESS = 'CUISINES_SUCCESS';
export const CUISINES_FAILURE = 'CUISINES_FAILURE';

export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION';

export const CLEAR_LOCATION_QUERY = 'CLEAR_LOCATION_QUERY';
export const CHANGE_HIGHLIGHTED_SUGGESTION = 'CHANGE_HIGHLIGHTED_SUGGESTION';

export const SHOW_VOTE_AREA_MODAL = 'SHOW_VOTE_AREA_MODAL';
export const HIDE_VOTE_AREA_MODAL = 'HIDE_VOTE_AREA_MODAL';

export const SHOW_UNDELIVERABLE_MODAL = 'SHOW_UNDELIVERABLE_MODAL';
export const HIDE_UNDELIVERABLE_MODAL = 'HIDE_UNDELIVERABLE_MODAL';

export const GOOGLE_MAPS_GEOLOCATION_REQUEST = 'GOOGLE_MAPS_GEOLOCATION_REQUEST';
export const GOOGLE_MAPS_GEOLOCATION_SUCCESS = 'GOOGLE_MAPS_GEOLOCATION_SUCCESS';
export const GOOGLE_MAPS_GEOLOCATION_FAILURE = 'GOOGLE_MAPS_GEOLOCATION_FAILURE';

export const GOOGLE_MAPS_SUGGESTIONS = 'GOOGLE_MAPS_SUGGESTIONS';
export const GOOGLE_MAPS_SUGGESTIONS_REQUEST = 'GOOGLE_MAPS_SUGGESTIONS_REQUEST';
export const GOOGLE_MAPS_SUGGESTIONS_SUCCESS = 'GOOGLE_MAPS_SUGGESTIONS_SUCCESS';
export const GOOGLE_MAPS_SUGGESTIONS_FAILURE = 'GOOGLE_MAPS_SUGGESTIONS_FAILURE';
export const GOOGLE_MAPS_CLEAR_SUGGESTIONS = 'GOOGLE_MAPS_CLEAR_SUGGESTIONS';
export const GOOGLE_MAPS_SELECT_SUGGESTION_SUCCESS = 'GOOGLE_MAPS_SELECT_SUGGESTION_SUCCESS';
export const GOOGLE_MAPS_SELECT_SUGGESTION_FAILURE = 'GOOGLE_MAPS_SELECT_SUGGESTION_FAILURE';

export const GOOGLE_MAPS_GEOCODE_REQUEST = 'GOOGLE_MAPS_GEOCODE_REQUEST';
export const GOOGLE_MAPS_GEOCODE_SUCCESS = 'GOOGLE_MAPS_GEOCODE_SUCCESS';
export const GOOGLE_MAPS_GEOCODE_FAILURE = 'GOOGLE_MAPS_GEOCODE_FAILURE';

export const GOOGLE_MAPS_PLACES = 'GOOGLE_MAPS_PLACES';
export const GOOGLE_MAPS_PLACES_REQUEST = 'GOOGLE_MAPS_PLACES_REQUEST';
export const GOOGLE_MAPS_PLACES_SUCCESS = 'GOOGLE_MAPS_PLACES_SUCCESS';
export const GOOGLE_MAPS_PLACES_FAILURE = 'GOOGLE_MAPS_PLACES_FAILURE';

export const BRAND = 'BRAND';
export const BRANDS = 'BRANDS';
